import React, { useCallback, useEffect, useState } from "react";
import "./Dashboard.css";
import "./PopUp.css";
import "../WNewUserTutorials/PopupBoxStyle.css";

import {
  SX_dashboard_right_arrow,
  SX_dashboard_star,
  Scrollx_animate,
  WavingHand,
  info,
  laptopScreenV3,
} from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectsByPagination } from "../../Redux/actions/projectsActions";
import {
  createProject,
  deleteAProject,
  createAGoogleProject,
  renameProject,
  updateProjectStatus,
  createCardProject,
} from "../../Redux/actions/projectActions";
import {
  skipUserModel,
  allTemplatesList,
  getCurrentPlan,
  userSeenTutorial,
  selectedPageOption,
} from "../../Redux/actions/commonActtion";
import {
  AiOutlineDelete,
  AiOutlineSortDescending,
  AiOutlineSortAscending,
} from "react-icons/ai";
import { FaChevronLeft, FaClone } from "react-icons/fa";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { SiGooglesheets } from "react-icons/si";
// import { toast } from "react-toastify";
import { read, utils } from "xlsx";

import { NavBar } from "../../UiComponents/index";
import { excelDataToProjectData } from "../../services/excelDataToProjectData";
import CloneProjectModal from "../ProjectV2/CloneProject/CloneProjectModal";
import UserInputModal from "./userInputModal";
import { Loader, Button, Dropdown_Status, Loader2 } from "../../Components";
import SuccessModal from "./SuccessModal";
import Templates from "./Templates";
import ScrollTemp from "./ScrollTemp";

import { FaChevronRight } from "react-icons/fa";
import { LuLoader2 } from "react-icons/lu";
import ProjectSkeleton from "../../Components/SkeletonLoader/ProjectSkeleton";
import Navbar from "../ProjectV2/Navbar/Navbar";
import { toast, ToastContainer } from "react-toastify";
import CustomToast, {
  defaultcustomToatStyle,
} from "../../Components/CustomToast/CustomToast";

export default function Dashboard(setIsPreviewOpen) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isProjectOpen, setIsProjectOpen] = useState(false);

  const [dateSort, setDateSort] = useState("desc");
  const [isNoticeDisplay, setIsNoticeDisplay] = useState(false);
  const [projectCloneModalOpen, setProjectCloneModalOpen] = useState(false);
  const [newProjectInputModalOpen, setNewProjectInputModalOpen] =
    useState(false);

  const [ProjectType, setProjectType] = useState("scroll");
  const [projectName, setProjectName] = useState("");
  const [resolution, setResolution] = useState("");
  // console.log("ProjectType ", ProjectType, "   resolution = ", resolution);

  const [loading, setLoading] = useState(false);
  const [loadOnClone, setLoadOnClone] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [cloneMsg, setCloneMsg] = useState(false);
  const [allprojectloading, setAllProjectLoading] = useState(false);
  const [production, setProduction] = useState(false);
  const [template, setTemplate] = useState(false);
  const [templateId, setTemplateId] = useState(0);
  const [projectIdForClone, seProjectIdForClone] = useState("");
  const [renameModal, setRenameModal] = useState({
    id: "",
    isOpen: false,
    title: "",
    isCard: false,
  });

  const [options, setOptions] = useState([
    { label: "No Status", value: "defaultStatusClass" },
    { label: "Approved", value: "approvedClass" },
    { label: "In Progress", value: "inProgressClass" },
    { label: "Need Review", value: "needsReviewClass" },
  ]);

  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const getStorageData = JSON.parse(localStorage.getItem("skipModels"));
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(
    getStorageData ? getStorageData.dashModalStatus : true
  );
  const [isPopupOne, setIsPopupOne] = useState(false);
  const [isPopupsecond, setIsPopupsecond] = useState(false);
  const [isPopupThird, setIsPopupThird] = useState(false);
  // const [isPopupFour, setIsPopupFour] = useState(false);
  const [createProjectRes, setCreateProjectRes] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [allTemplateLoading, setAllTemplateLoading] = useState(false);

  const updateTutorialStatus = async (status) => {
    await dispatch(userSeenTutorial(status));
  };

  const nextToContinue = (key, val, status) => {
    updateTutorialStatus(status);
  };

  const skipModel = () => {
    dispatch(
      skipUserModel({ dashModalStatus: false, layoutModalstatus: true })
    );
    setIsWelcomeModalOpen(false);
    localStorage.setItem(
      "skipModels",
      JSON.stringify({ dashModalStatus: false, layoutModalstatus: true })
    );
    setIsWelcomeModalOpen(false);
    setIsPopupOne(false);
    setIsPopupsecond(false);
    setIsPopupThird(false);
  };

  let { projects, totalProjects } = useSelector((state) => state?.projects);

  let projectLoadingInOnePage = window.innerWidth > 2500 ? 15 : 8;
  let totalPages = Math.ceil(totalProjects / projectLoadingInOnePage);

  const templatesList = useSelector(
    (state) => state?.commonReducer?.templates?.data
  );

  const sortByDate = (sortType) => {
    setDateSort(sortType);
    projects = projects.sort((a, b) => {
      if (sortType === "asc")
        return new Date(a.createdAt) - new Date(b.createdAt);
      else return new Date(b.createdAt) - new Date(a.createdAt);
    });
  };

  useEffect(
    (dateSort) => {
      sortByDate(dateSort);
    },
    [projects, setDateSort]
  );

  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  const handleChangeStatus = (index, value, project_id, isCard) => {
    const idx = options.findIndex((opt) => opt.value === value);
    dispatch(updateProjectStatus(project_id, value, idx, isCard));
  };

  const getAllProject = () => {
    setAllProjectLoading(true);
    dispatch(getCurrentPlan());
    dispatch(
      getProjectsByPagination("", projectLoadingInOnePage, pageNo, "")
    ).then(() => {
      setAllProjectLoading(false);
    });
  };

  const getAllTemplates = () => {
    setAllTemplateLoading(true);
    dispatch(allTemplatesList()).then(() => {
      setAllTemplateLoading(false);
    });
  };

  const increment = () => {
    setPageNo(pageNo < totalPages ? pageNo + 1 : pageNo);
  };

  const decrement = () => {
    setPageNo(pageNo > 1 ? pageNo - 1 : pageNo);
  };

  useEffect(() => {
    getAllProject();
    if (window.location.href.endsWith("dashboard")) {
      document.getElementById("navbar_0")?.classList?.remove("hidden");
    }
  }, [pageNo]);

  useEffect(() => {
    getAllTemplates();
  }, []);

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const fileNameWithoutExt = file.name.split(".").slice(0, -1).join(".");
        const projectData = excelDataToProjectData(
          fileNameWithoutExt,
          jsonData
        );
        dispatch(createProject(projectData));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      console.log(err);
    }
  };

  const handleGoogleProjectCreateButtonClick = async () => {
    try {
      if (projectName && ProjectType === "card") {
        // console.log("Submit Handler for card ", ProjectType, projectName, resolution);
        await setLoading(true);
        const res = await dispatch(
          createCardProject(projectName, templateId, resolution)
        );
        setCreateProjectRes(res?.success);
        if (res?.success) {
          setNewProjectInputModalOpen(false);
          await setLoading(false);
          setProjectName("");
          setSuccessModal(true);
        } else {
          await setLoading(false);
          toast.error("Something Is Wrong");
          setProjectName("");
        }
      } else {
        // console.log(" Submit Handler For Scroll ", ProjectType, projectName, resolution);
        await setLoading(true);
        const res = await dispatch(
          createAGoogleProject(projectName, templateId)
        );
        setCreateProjectRes(res?.success);
        if (res?.success) {
          setNewProjectInputModalOpen(false);
          await setLoading(false);
          setProjectName("");
          setSuccessModal(true);
        } else {
          await setLoading(false);
          toast.error("Something Is Wrong");
          setProjectName("");
        }
      }
    } catch (err) {
      await setLoading(false);
    }
  };
  
    const OptionHandler = (val, projectId, isCard) => {
      dispatch(selectedPageOption(val, projectId, isCard));
    };

  const navigateToProject = (projectId, isCard) => {
    OptionHandler("projectLayout", projectId, isCard || false);
    if(isCard){
      navigate(`/dashboard/card/${projectId}`, { state: {isDashboard:false, isCard: isCard } });
    }else{
      navigate(`/dashboard/scroll/${projectId}`, { state: {isDashboard:false, isCard:false } });
    }    
  };

  const handleNavigate = (projectId, isCard) => {  
    navigateToProject(projectId, isCard);    
    localStorage.setItem(
      "isCard",
      JSON.stringify(isCard === true ? true : false)
    );
  };

  useEffect(() => {
    setIsProjectOpen(true);
  }, [navigateToProject]);

  const deleteProject = (projectId, projectName, isCard) => {
    // const confirm = window.confirm(
    //   `Are you sure! You want to delete project (${projectName})?`
    // );
    // if (confirm) dispatch(deleteAProject(projectId, isCard));

    const handleConfirm = (closeToast) => {
      console.log(" 1  is Confirm");
      dispatch(deleteAProject(projectId, isCard));
      closeToast();
      setSuccessModal(true);
      setSuccessMsg(`Project has been successfully deleted.`);
    };

    toast(
      ({ closeToast }) => (
        <CustomToast
          title="Are you sure!"
          content={
            <>
              You want to delete project <br /> ({projectName})?
            </>
          }
          onConfirm={() => handleConfirm(closeToast)}
          onCancel={closeToast}
        />
      ),
      defaultcustomToatStyle
    );
  };

  const handleNewProjectName = async () => {
    if (projectName) {
      await setNewProjectInputModalOpen(false);
      handleGoogleProjectCreateButtonClick();
    }
  };

  const handleRenameProjec = async () => {
    const res = await dispatch(
      renameProject(renameModal?.id, renameModal?.title, renameModal?.isCard)
    );
    if (res?.success) {
      setRenameModal((prev) => ({
        ...prev,
        isOpen: false,
        title: "",
        id: "",
        isCard: false,
      }));
      // toast.success(res?.message);

      setTimeout(() => {
        toast(
          <CustomToast title="" content={res?.message} />,
          defaultcustomToatStyle
        );
      }, 300);
    } else {
      toast.error("!Oops Something Is Wrong");
    }
  };

  const skeletonComponent = () => {
    let skeletonArr = [];
    let lastPageSkeleton = totalProjects % projectLoadingInOnePage;
    let noOfSkeleton =
      totalPages === pageNo ? lastPageSkeleton : projectLoadingInOnePage;
    for (let i = 0; i < noOfSkeleton; i++) {
      skeletonArr.push(<ProjectSkeleton key={i} />);
    }
    return skeletonArr;
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );



  return (
    <>
      {" "}
      <ToastContainer closeButton={CloseButton} />
      {loadOnClone ? (
        <div className="modal-overlayLoader">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="140px"
            height="140px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">
            Duplicating Project...
          </p>
        </div>
      ) : null}
      <div
        className={"tainer w-full h-full"}
        // isOpen={isWelcomeModalOpen}
        // onRequestClose={continueToHomeDashboard}
        contentLabel="Welcome Modal"
      >
        <div
          className="PopUPoneContainer w-full h-full"
          // isOpen={isWelcomeModalOpen}
          // onRequestClose={continueToHomeDashboard}
          contentLabel="Popup Modal"
        >
          {size.winWidth > 1000 ? (
            <div className={"w-full h-full dashContainer"}>
              {/* {successMsg && <SuccessModal successModal={successModal} setSuccessModal={setSuccessModal} deleteMsg={successMsg}/>} */}
              <div className="dashHead">
                <NavBar />
                {/* <Navbar isProjectOpen={isProjectOpen} setIsProjectOpen={setIsProjectOpen}/> */}
              </div>

              <div className="main_dash_block dashBody">
                <div className="main_dash_div">
                  {(newProjectInputModalOpen || renameModal) && (
                    <UserInputModal
                      newProjectInputModalOpen={newProjectInputModalOpen}
                      setNewProjectInputModalOpen={setNewProjectInputModalOpen}
                      ProjectType={ProjectType}
                      setProjectType={setProjectType}
                      projectName={projectName}
                      setProjectName={setProjectName}
                      setResolution={setResolution}
                      handleNewProjectName={handleNewProjectName}
                      renameModal={renameModal}
                      setRenameModal={setRenameModal}
                      handleRenameProjec={handleRenameProjec}
                    />
                  )}
                  {loading ? (
                    <div className="modal-overlayLoader">
                      <Loader2 label={"Project Creating..."} />
                    </div>
                  ) : null}
                  {successModal && (
                    <SuccessModal
                      successModal={successModal}
                      setSuccessModal={setSuccessModal}
                      cloneMsg={cloneMsg}
                      setCloneMsg={setCloneMsg}
                      deleteMsg={successMsg}
                    />
                  )}
                  {projectIdForClone && projectCloneModalOpen && (
                    <div className="">
                      <CloneProjectModal
                        projectCloneModalOpen={projectCloneModalOpen}
                        setProjectCloneModalOpen={setProjectCloneModalOpen}
                        projectId={projectIdForClone}
                        setCloneMsg={setCloneMsg}
                        setSuccessModal={setSuccessModal}
                        loading={loadOnClone}
                        setLoading={setLoadOnClone}
                        projectType={ProjectType}
                      />
                    </div>
                  )}

                  <div className="DashBoardContainer w-full h-full  ">
                    <div className="bg-black w-full h-[43%]  flex justify-center items-center">
                      <div className="right_add_block w-[85%] h-[70%] rounded-[1.5rem]">
                        <div className="w-full h-full flex items-center flex-col justify-center rounded-[1.5rem] py-7 ">
                          <div className=" w-full flex items-center justify-between pl-[4%] pr-[3.5%]">
                            <div className="flex">
                              <h1 className="right_heading_text manrope-800 pb-[26px]  pr-[10px]">
                                Select a Template to Get Started
                              </h1>
                              <img
                                className="w-8 h-6"
                                src={SX_dashboard_star}
                                alt=""
                              />
                            </div>
                            <div className="">
                              <img
                                className="w-5"
                                src={info}
                                alt=""
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  window.open(`/help/66f25db207e246eced9ecfda`)
                                }
                              />
                            </div>
                          </div>
                          <div className="w-full">
                            <div className="w-[100%] h-fit  snap_inline">
                              <ScrollTemp
                                template={template}
                                templatesList={templatesList}
                                setTemplate={setTemplate}
                                setTemplateId={setTemplateId}
                                setNewProjectInputModalOpen={
                                  setNewProjectInputModalOpen
                                }
                                allTemplateLoading={allTemplateLoading}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Project Table List */}

                    <div className="w-full h-[57%]  bg-[#121212]">
                      <div className="w-[85%] py-[30px] px-[7.5%]">
                        <h1 className="manrope-800 text-white text-2xl">
                          My Projects
                        </h1>
                      </div>
                      <div className="w-full flex flex-col justify-center">
                        <div className="w-full flex justify-center">
                          <div className="xl:w-[85%] pr-[12px] 2xl:w-[w-75%]  h-[55px] flex justify-center w-[70%] items-center  rounded-[.8rem] ShadeGrayLinear100">
                            <div className="text-[18px] w-[23%]   text-white  text-left manrope-600 pl-[20px]">
                              Project Name
                            </div>

                            <div className=" text-[18px] w-[13%]  text-white  flex items-center justify-center  manrope-600 ">
                              Type
                            </div>

                            <div className=" text-[18px] w-[27%] text-center text-white  flex items-center justify-center  manrope-600 ">
                              Status
                            </div>

                            <div className="text-[18px] w-[22%]   text-white  text-center flex items-center justify-center">
                              <div className="text-center text-[18px] manrope-600">
                                Created
                              </div>
                              <div
                                className="cursor-pointer"
                                onClick={() =>
                                  dateSort === "asc"
                                    ? sortByDate("desc")
                                    : sortByDate("asc")
                                }
                              >
                                {dateSort === "asc" ? (
                                  <AiOutlineSortAscending />
                                ) : (
                                  <AiOutlineSortDescending />
                                )}
                              </div>
                            </div>

                            <div className=" text-[18px] w-[25%]  text-white  flex items-center justify-center  manrope-600 ">
                              Options
                            </div>
                            <div className=" text-[18px] w-[10%]  text-white  flex items-center justify-end pr-[20px] manrope-600 ">
                              Edit Project
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Project Table List */}

                      <div className="flex  w-[100%]  h-[59%]    justify-center  overflow-auto">
                        <div className="xl:w-[85%] 2xl:w-[w-75%] overflow-auto w-[80%] pb-[40px] scroll_width1">
                          {allprojectloading ? (
                            <div className="w-[100%]">
                              {/* <LuLoader2 className="text-white text-[2rem] animate-spin m-auto mt-5"/> */}
                              {skeletonComponent()}
                            </div>
                          ) : projects && projects?.length ? (
                            projects?.map((project, index) => {
                              return project ? (
                                <>
                                  <div
                                    className="white-80 w-[100%] justify-center text-lg  dashTable  flex items-center border-b-[1px] border-[#3A3A3A] first:border-t-[1px]"
                                    key={index}
                                  >
                                    <div
                                      className="pl-[20px] text-base text-left w-[23%] capitalize white-80 manrope-600  h-12 flex items-center cursor-pointer"
                                      onClick={() =>
                                        handleNavigate(
                                          project?._id,
                                          project?.isCard
                                        )
                                      }
                                    >
                                      <span
                                        className="cursor-pointer"
                                        title={project?.title}
                                      >
                                        {project?.title.length > 25
                                          ? project?.title.slice(0, 25) + "..."
                                          : project?.title}
                                      </span>
                                      {/* <span className="cursor-pointer" onClick={()=>navigate(`/dashboard/cardLayout/${project?._id}`)}>{project?.title}</span> */}
                                    </div>

                                    <div
                                      className="w-[13%] flex items-center justify-center manrope-600 text-base curson-pointer"
                                      onClick={() =>
                                        handleNavigate(
                                          project?._id,
                                          project?.isCard
                                        )
                                      }
                                    >
                                      <span>
                                        {project?.isCard ? "Card" : "Scroll"}
                                      </span>
                                    </div>

                                    <div className="text-base  w-[27%] white-80 h-12 flex items-center justify-center  cursor-pointer">
                                      <h1 className="">
                                        <Dropdown_Status
                                          options={options}
                                          value={
                                            project?.projectStatus === ""
                                              ? "No Status"
                                              : project?.projectStatus
                                          }
                                          projectStatus={project?.projectStatus}
                                          selectedID={project?.statusId}
                                          onChange={(value) => {
                                            handleChangeStatus(
                                              index,
                                              value,
                                              project?._id,
                                              project?.isCard
                                            );
                                          }}
                                        />
                                      </h1>
                                    </div>

                                    <div
                                      className=" text-base white-80  w-[22%] h-12 text-center flex items-center justify-center  manrope-600 cursor-pointer"
                                      onClick={() =>
                                        handleNavigate(
                                          project?._id,
                                          project?.isCard
                                        )
                                      }
                                    >
                                      {new Date(
                                        project?.createdAt
                                      ).toDateString()}{" "}
                                      -{" "}
                                      {new Date(project?.createdAt)
                                        .toTimeString()
                                        .slice(0, 8)}
                                    </div>
                                    <div className="flex w-[25%] items-center justify-center">
                                      <div className="pr-2  relative">
                                        <span
                                          className=" cursor-pointer white-80 edit"
                                          onClick={() =>
                                            setRenameModal((prev) => ({
                                              ...prev,
                                              isOpen: true,
                                              id: project?._id,
                                              title: project?.title,
                                              isCard: project?.isCard,
                                            }))
                                          }
                                        >
                                          {/* <img className="mt-[4px] w-[25px]" src={Write} alt="" /> */}
                                          <MdOutlineDriveFileRenameOutline />
                                        </span>
                                      </div>
                                      <div className=" relative">
                                        <div
                                          className="px-2 white-80 clone"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            setProjectCloneModalOpen(true);
                                            seProjectIdForClone(project?._id);
                                            setProjectType(
                                              project?.isCard
                                                ? "card"
                                                : "scroll"
                                            );
                                          }}
                                        >
                                          {/* <img className="w-[19px]" src={duplicate} alt="" /> */}

                                          <FaClone />
                                        </div>
                                      </div>

                                      <div className="px-2 relative">
                                        <div className="flex  white-80 text-xl ">
                                          {project?.googleSheetLink ? (
                                            <span
                                              className=" sheet cursor-pointer"
                                              onClick={() =>
                                                window.open(
                                                  project?.googleSheetLink
                                                )
                                              }
                                            >
                                              {/* <img className="w-[10px]" src={dshCredit} alt="" /> */}

                                              <SiGooglesheets />
                                            </span>
                                          ) : project?.googleSpreadSheetId ? (
                                            <span
                                              className="px-2 cursor-pointer white-80"
                                              onClick={() =>
                                                window.open(
                                                  `https://docs.google.com/spreadsheets/d/${project?.googleSpreadSheetId}`
                                                )
                                              }
                                            >
                                              {/* <img className="w-[15px]" src={dshCredit} alt="" /> */}
                                              <SiGooglesheets />
                                            </span>
                                          ) : null}
                                        </div>
                                      </div>

                                      <div className="px-2 relative">
                                        <span
                                          className=" cursor-pointer white-80 delete"
                                          onClick={() =>
                                            deleteProject(
                                              project?._id,
                                              project?.title,
                                              project?.isCard
                                            )
                                          }
                                        >
                                          {/* <img className="w-[15px]" src={dshDelete} alt="" /> */}
                                          <AiOutlineDelete />
                                        </span>
                                      </div>
                                    </div>
                                    <div className="w-[10%] flex justify-center items-center text-center">
                                      <img
                                        onClick={() =>
                                          handleNavigate(
                                            project?._id,
                                            project?.isCard
                                          )
                                        }
                                        className="  w-[24px] cursor-pointer"
                                        src={SX_dashboard_right_arrow}
                                        alt=""
                                      />
                                    </div>

                                    {/* <td>
                                  <span
                                    className="mx-2 cursor-pointer text-zink-600"
                                    onClick={() =>
                                      navigateToProject(project._id)
                                    }
                                  >
                                    <GrLinkNext/>
                                  </span>
                                </td> */}
                                  </div>
                                </>
                              ) : (
                                ""
                              );
                            })
                          ) : (
                            <tr>
                              <td>
                                <p className="all_project_loading pl-[20px] pt-[20px]">
                                  Create Project to Get Started
                                </p>
                              </td>
                            </tr>
                          )}
                        </div>
                      </div>
                      {totalProjects > projectLoadingInOnePage && (
                        <div className="  manrope-800 h-[11%] select-none text-white flex justify-center gap-[1rem]  items-center w-full">
                          <p
                            className="Fmanrope-800 flex text-sm 3xl:text-base items-center cursor-pointer hover:text-gray-400"
                            onClick={decrement}
                          >
                            <FaChevronLeft />
                            prev
                          </p>
                          <p className="manrope-800 text-[0.8rem]">
                            {pageNo} / {totalPages}
                          </p>
                          <p
                            className="manrope-800 flex text-sm 3xl:text-base items-center cursor-pointer hover:text-gray-400"
                            onClick={increment}
                          >
                            next
                            <FaChevronRight onClick={increment} />
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* ==================(1  WELCOME POPUP)==================== */}
              <div
                className={
                  isWelcomeModalOpen === true ? "wmcOverlay" : "wmcOverlayNone"
                }
              >
                {" "}
                <div className="w-full h-full wmcOverlaySecond backdrop-blur-sm"></div>
              </div>

              {isWelcomeModalOpen && (
                <div
                  className={
                    size.winWidth < 1000 ? "hideComp" : "welcomeContent"
                  }
                >
                  <div className="w-full h-full flex flex-col justify-center items-center">
                    <div className="w-full flex justify-start items-center cursor-default ">
                      <h1 className="text-left text-white text-3xl tracking-wide manrope-800">
                        Take a quick tour to <br />
                        create your end credits
                      </h1>
                    </div>

                    <div className="w-full pt-[15px] pb-4 flex flex-col justify-start items-center">
                      <p className="text-base w-full  text-left manrope-400 text-white cursor-default">
                        Watch a short 2-minute walkthrough to quickly learn
                      </p>
                      <p className="text-base w-full  text-left manrope-400 text-white cursor-default">
                        how to create, edit, and render end credits with ease.
                      </p>
                    </div>

                    <div className="w-full flex flex-col justify-center align-center">
                      <button
                        className="w-full mb-4 rounded-xl py-[10px] text-white text-center bg-[#5e51d1] text-[1em] manrope-600"
                        onClick={() => {
                          skipModel(); 
                          window.open('/help/', '_blank'); // navigate to /help/ in the same tab
                        }}
                      >
                        
                          Watch 2-Minute Video Now
                      
                      </button>
                      <button
                        className="text-white rounded-xl  py-[10px] bg-[#2a2b36] w-full text-center text-[1em] manrope-400"
                        onClick= {skipModel}
                      >
                        Skip
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              id="warning-messageas"
              style={{ width: "100%", height: "100%" }}
            >
              <div className="w-full h-full  bg-[#121212] md:flex md:flex-row flex flex-col-reverse justify-center items-center  ">
                <div className=" md:w-[55%] md:h-1/2 h-[35%]  flex justify-center items-center">
                  <div className="relative   text-white text-4xl flex flex-col justify-center items-center text-center">
                    <img
                      className="w-80 md:mt-[0px] mt-[-250px] z-10 fixed"
                      src={laptopScreenV3}
                      alt=""
                    />
                  </div>
                </div>
                <div className=" md:w-[45%] w-full md:h-full  h-[65%]   flex justify-center items-center bg-white">
                  <div className=" md:w-[85%] w-[90%]  h-1/2 flex flex-col justify-center items-center ">
                    <div className="flex flex-col justify-center items-center sm:mt-[0px] mt-[-35px] sm:px-[0px] px-[25px]">
                      <h1 className="text-black md:text-[26px] text-2xl  manrope-800  pb-4 text-center">
                        Thanks for signing up!
                      </h1>
                      <h3 className="manrope-400 text-base text-[#585858] py-[10px] text-center ">
                        We've sent you an email with some exciting details.
                      </h3>
                      <h3 className="manrope-400 text-base text-[#585858] py-[10px] text-center ">
                        For the best experience, grab your laptop or desktop
                        because our app is not available on phones.
                      </h3>
                      <h3 className="manrope-400 text-base text-[#585858] pt-[10px] text-center ">
                        Check your inbox and let the cinematic journey begin!
                        🎥✨
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
